<template>
    <b-modal
        v-model="modalAcceptLicense.isOpen"
        title="Contrato de licencia para el uso de Soluquim"
        hide-footer
    >

        <b-row>
            <b-col md="2" sm="2" class="text-center">
                <i class="fa fa-info-circle iconInfoAlert"></i>
            </b-col>
            <b-col>
                <p class="text-black font-weight-bold">Aún no has aceptado el contrato de licencia para el uso de Soluquim.</p>
                <p class="mt-2">El responsable debe aceptar el contrato de
                la licencia para el uso de Soluquim. por favor acéptalo para poder continuar usando
                nuestro sistema.</p>
            </b-col>
        </b-row>

        <b-row class="mt-4">
            <hr />
            <div class="display-flex jsutify-content-center flex-row">
                <b-button variant="secondary" @click="cancelProcessAlertLicence">
                    <i class="fa fa-close" />
                    Cancelar
                </b-button>
                <b-button class="mr-3 ml-2" variant="primary" @click="goDetailsLicence">
                    Ver detalles de la licencia
                    <i class="fa fa-arrow-right" />
                </b-button>
            </div>
        </b-row>

    </b-modal>
</template>

<script>

import { mapMutations, mapState } from 'vuex';

export default {
    name: 'ModalAlertNotAccepted',
    data() {
        return { }
    },
    computed: {
         ...mapState('licencias', [
             'modalAcceptLicense',
         ]),
    },
    methods: {
        ...mapMutations('licencias', [
            'setModalAcceptLicense',
            'setModalDetailsLicence',
            'setIsVisibleDetailsLicensingContract',
        ]),
        // cerrar modal de alerta sobre licencia del sistema
        cancelProcessAlertLicence() {
            this.setModalAcceptLicense(false);
        },
        // ver detalles de la licencia
        goDetailsLicence() {
            this.cancelProcessAlertLicence();
            this.setIsVisibleDetailsLicensingContract('close');
            this.setModalDetailsLicence(true);
        },
    }
};
</script>

<style scoped>
.iconInfoAlert{
    font-size: 70px;
    color: grey;
}
</style>
